import { useContext, useMemo } from "react";
import { ModalSettingContext } from "../../index";
import Select from "@UI/New/Select";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import s from './index.module.css';
import { usersAPI } from "@/api";
import { useApiSearch } from "@/hooks/useApiSearch";

export const SeminarianSelectionForConferenceTypeCustomizable = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    const allEmployeesParams = useMemo(() => {
            return (
                {
                    'employeesOnly': 1,
                    'per-page': 1000
                }
            )
    }, []);
    
        const {
            data: allEmployees = [],
            loading: loadingAllEmployees,
            searchQuery: searchQueryAllEmployees,
            setSearchQuery: setSearchQueryAllEmployees
        } = useApiSearch({
            apiMethod: usersAPI.searchUsersForSelect,
            responseKey: 'data',
            searchKey: 'name',
            params: allEmployeesParams
        });
    
        const fieldsAllEmployees = {
            loading: loadingAllEmployees,
            showSearch: true,
            allowClear: true,
            filterSort: compareOptionsByLabel,
            filterOption: false,
            onChange: e => setFieldInState({field: 'speaker_id', value: e }),
            options: allEmployees,
            value: state.speaker_id,
            placeholder: 'Выберите спикера',
            onSearch: setSearchQueryAllEmployees,
            notFoundContent: searchQueryAllEmployees.length < 3 
                ? "Введите 3 или более символов" 
                : "Спикеры не найдены" 
        };

    return (
        <Select 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsAllEmployees} 
        />
    );
};